import styled from 'styled-components';

import { lightTheme } from '@/styles/themes/light';

const { fonts, palette } = lightTheme;

export const InfoIcon = styled.span`
	margin-left: 8px;

	.anticon {
		font-size: 16px;
		color: #262626;
		cursor: pointer;
	}
`;

export const RequiredAsterisk = styled.span`
	color: ${palette.risk.high.default};
`;

export const InfoIconWrapper = styled.span`
	display: inline-flex;
	vertical-align: super;
	font-size: ${fonts.body.md.fontSize};
`;